export enum FormControlType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  HEADER = 'header',
  FILE_UPLOAD = 'fileUpload',
  RADIO_GROUP = 'radioGroup',
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  DATE = 'date',
  DATE_TIME = 'datetime',
  TIME = 'time',
  AUTOCOMPLETE = 'autocomplete',
  BUTTONS_SELECT = 'buttonsSelect',
  CHECKBOX = 'checkbox',
  ROW = 'row',
  STEP = 'step',
  ALTERNATE_ENTITY = 'alternateEntity',
  EVENT_DISPLAY_TIME = 'eventDisplayTime',
  INFO = 'info',
  BOOKING_SELECT = 'bookingSelect',
  BOOKING_DETAILS = 'bookingDetails',
  LICENSE_PLATES = 'licensePlates',
  TAG_INPUT = 'tagInput',
  INFO_AREA = 'infoArea'
}

// controls that only show data: never sent with the form, never make it touched
export const DISPLAY_ONLY_CONTROLS = [
  FormControlType.INFO,
  FormControlType.HEADER,
  FormControlType.INFO_AREA
];

export function isDisplayOnlyControl(control: FormControlType) {
  return DISPLAY_ONLY_CONTROLS.includes(control);
}
